import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { createUploadLink } from 'apollo-upload-client';
import fetch from 'unfetch';

const httpOptions = {
    uri: '/graphql',
    credentials: 'same-origin',
    fetch: fetch,
};

const httpLink = ApolloLink.split(
    operation => operation.getContext().hasUpload,
    createUploadLink(httpOptions),
    new HttpLink(httpOptions)
);

// Read the CSRF token fresh on every request so Turbolinks navigation never
// leaves the client holding a stale token from a previous page load.
const csrfLink = new ApolloLink((operation, forward) => {
    const token =
        document.querySelector('meta[name="csrf-token"]')?.content ||
        document.querySelector('meta[name="csrf_token"]')?.content;
    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            'X-CSRF-Token': token,
        },
    }));
    return forward(operation);
});

const client = new ApolloClient({
    link: ApolloLink.from([csrfLink, httpLink]),
    cache: new InMemoryCache(),
});

export default client;